/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import { CALENDER_SCREEN, COMMON } from '../../global/Constants';
//import './activity-calendar.css';
import ApiServices from "../../providers/ApiServices";
import Utilities from '../../global/Utilities';
//import ViewImage from '../common/ViewImage';
import AcceptRejectButton from '../common/AcceptRejectButton';
import DataProvider from '../../providers/DataProvider';
import ViewOfflineImage from '../common/ViewOfflineImage';


class IndividualVisitView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isFarmer: true,
            activity: null,
            data: null,
            user: { name: "", phone: "" },
            address: "Fetching address..."
        }
    }

    componentDidMount() {
        const { activity } = this.props;
        Utilities.LogPrint("Activity Data ==", activity);
        if (activity) {
            this.setState({ activity: activity });
        }
    }

    getActivityById(id) {
        this.setState({ isLoading: true });
        const request = JSON.stringify({
            activity_id: id
        });
        try {
            ApiServices.getActivityById(request)
                .then(response => {
                    Utilities.LogPrint("API_Activity_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data != null) {
                            let user = {}
                            if (data?.retailer_id === 0) {
                                user = {
                                    name: data?.krishak?.name,
                                    phone: data?.krishak?.phone
                                }
                            } else {
                                user = {
                                    name: data?.retailer?.retailer_name,
                                    phone: data?.retailer?.phone
                                }
                            }
                            this.setState({ data: data, user: user });

                            if (data?.individual_visit) {
                                const individualVisit = data?.individual_visit;
                                this.getAddressFromLatLong(individualVisit.latitude, individualVisit.longitude);
                            } else {
                                this.setState({ address: COMMON.LOCATION_ERROR_MESSAGE });
                            }

                        }
                    } else {
                        alert(response.message);
                        Utilities.LogPrint("Status", response.message);
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ isLoading: false, errorMsg: error });
        }
    }


    getFormattedDate() {
        let selectedDate = null;
        if (this.props.location.state !== undefined) {
            selectedDate = this.props.location.state.selectedDate;
            return Moment(selectedDate).format('dddd, DD MMM, yyyy');
        }
    }

    handleBack = () => {
        this.props.history.goBack();
    }


    handleAcceptButton = () => {
        this.props.history.goBack();
    }

    handleRejectButton = () => {
        this.props.history.goBack();
    }

    getSeasonNameById = (seasonId) => {
        const season = DataProvider.getInstance().getSeasonById(seasonId);
        if (season) {
            return season.season_name;
        }
        return "";
    }

    getSubActivityNameById = (subActivityId) => {
        const subActivity = DataProvider.getInstance().getSubActivitiesById(subActivityId);
        if (subActivity) {
            return subActivity.sub_activity_name;
        }
        return "";
    }

    getRejectReasonById = (activityTypeId, rejectId) => {
        const rejectReasons = DataProvider.getInstance().getRejectReasons(activityTypeId);
        if (rejectReasons) {
            const reason = rejectReasons.find(item => item.reject_id === rejectId);
            Utilities.LogPrint("reason", reason);
            if (reason) {
                return reason.title;
            }
            return "";
        }
        return "";
    }

    render() {
        const { activity, user } = this.props;
        //Utilities.LogPrint("Activity Data ==", this.props.activity);

        if (activity) {
            const data = activity?.data;
            const isFarmer = activity.retailer_id === 0 ? true : false;

            let reject = null;
            if (activity?.activity_reject !== null && activity?.activity_reject !== undefined) {
                reject = this.getRejectReasonById(activity.activity_type_id, activity.activity_reject.reject_id);
            }


            return (
                <div>
                    {/* Reject Reason */}
                    {
                        activity.activity_reject && activity.activity_status_id === 4 ?
                            <div className="row">
                                <div className="col-12 reject-activity-msg">
                                    <i className="customic ic-rejected"></i>
                                    <span>{reject}.</span>
                                </div>
                            </div> : null
                    }
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="row mb-3">
                                        <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">{isFarmer ? CALENDER_SCREEN.FARMER_NAME : CALENDER_SCREEN.RETAILER_NAME}</div>
                                        <div className="col-lg-12 col-7">
                                            <span className="d-block font-weight-medium">{user?.name}</span>
                                            <span className="d-block font-weight-medium">+91 - {user?.phone}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="row mb-3">
                                        <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Stage of Visit</div>
                                        <div className="col-lg-12 col-7">
                                            <span className="d-block font-weight-medium">{this.getSeasonNameById(data?.season_id)}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Sub Activity</div>
                                        <div className="col-lg-12 col-7">
                                            <span className="d-block font-weight-medium">{this.getSubActivityNameById(data?.sub_activity_id)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="row mb-3">
                                        <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Location</div>
                                        <div className="col-lg-12 col-7">
                                            {/* <span className="d-block font-weight-medium">Unnamed Road, Amargarh, Haryana 126116, India</span> */}
                                            <span className="d-block font-weight-medium">{data?.address ? data?.address : COMMON.LOCATION_ERROR_MESSAGE}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={data?.remark ? "row mx-sm-0" : "d-none"}>
                                <hr className="w-100 bdr-color-gray m-0" />
                            </div>

                            <div className="row">
                                {/* Remarks */}
                                {
                                    data?.remark ?
                                        <div className="col-md-6 col-12">
                                            <span className="d-flex w-100 align-items-center mt-2">{COMMON.REMARKS}</span>
                                            <span className="d-flex font-weight-medium mb-2">{data.remark}</span>


                                        </div> : null
                                }

                                {/* Images */}
                                {
                                    data?.activity_images.length ?
                                        <div className="col-md-6 col-12">
                                            <div className="row mx-sm-0 d-md-none">
                                                <hr className="w-100 bdr-color-gray m-0" />
                                            </div>

                                            <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mb-2">{COMMON.IMAGES}</span>
                                            <div className="row row7-5 mb-3">
                                                {
                                                    data?.activity_images?.map((image, i) => (
                                                        <ViewOfflineImage key={i} image={image.image_url} />
                                                    ))
                                                }
                                            </div>
                                        </div> : null
                                }

                            </div>

                            <AcceptRejectButton
                                activity={activity}
                                handleAcceptButton={this.handleAcceptButton}
                                handleRejectButton={this.handleRejectButton}
                            />
                        </div>
                    </div>
                </div>

            )
        } else {
            return null;
        }
    }
}

export default withRouter(IndividualVisitView)